import { all, takeLatest } from 'redux-saga/effects';

import * as actionTypes from 'store/personalPlan/actionTypes';

import { completeWorkout } from './completeWorkout';
import { generatePlan } from './generatePlan';
import { getCompletedPlanStatistics } from './getCompletedPlanStatistics';
import { getCurrentPlan } from './getCurrentPlan';
import { getWorkout } from './getWorkout';
import { joinBranchContent } from './joinBranchContent';

export default function* watchUser() {
    yield all([
        takeLatest(actionTypes.GET_COMPLETED_PLAN_STATISTICS, getCompletedPlanStatistics),
        takeLatest(actionTypes.GET_CURRENT_PLAN, getCurrentPlan),
        takeLatest(actionTypes.GENERATE_PLAN, generatePlan),
        takeLatest(actionTypes.COMPLETE_WORKOUT, completeWorkout),
        takeLatest(actionTypes.SELECT_WORKOUT_DAY, getWorkout),
        takeLatest(actionTypes.JOIN_BRANCH_CONTENT_REQUEST, joinBranchContent),
    ]);
}
